import React, { FC, useEffect } from 'react'
import { motion, useAnimation } from 'framer-motion'
import { useInView } from 'react-intersection-observer'
import s from './Advantages.module.scss'
import { ReactComponent as LineAdvantages1 } from './../../../assets/icons/line-Advantages1.svg'
import { ReactComponent as LineAdvantages2 } from './../../../assets/icons/line-Advantages2.svg'
import { ReactComponent as LineAdvantages3 } from './../../../assets/icons/line-Advantages3.svg'
import { ReactComponent as LineAdvantages4 } from './../../../assets/icons/line-Advantages4.svg'
import { ReactComponent as LineAdvantages5 } from './../../../assets/icons/line-Advantages5.svg'
import { ReactComponent as LineAdvantages6 } from './../../../assets/icons/line-Advantages6.svg'
import { ReactComponent as LineAdvantages7 } from './../../../assets/icons/line-Advantages7.svg'

const isMobile = window.innerWidth <= 768;
const animation = {
    hidden: { opacity: 0, x: isMobile ? -200 : -1000 },
    visible: (i: number) => ({
        opacity: 1,
        x: 0,
        transition: {
            delay: isMobile ? i * 0.2 : i * 0.3,
            duration: isMobile ? 0.3 : 0.5,
        }
    }),
    hovered: {
        x: 40,
        transition: { duration: 0.1 },
    },
    initialPosition: {
        x: 0,
        transition: { duration: 0.1 },
    }
}

const Advantages: FC = () => {

    const controls = useAnimation()
    const { ref, inView } = useInView({ threshold: 0.1, triggerOnce: true })

    useEffect(() => {
        if (inView) {
            controls.start('visible')
        }
    }, [controls, inView])

    return (
        <section className={s.section}>
            <LineAdvantages2 className={`${s.lineAdvantages} ${s.lineAdvantages_line2}`} />
            {/* <LineAdvantages6 className={`${s.lineAdvantages} ${s.lineAdvantages_line6}`} /> */}
            <div className={`${s.container} container`}>
                <h2 className={`${s.title} title`}><span /> ПОЧЕМУ ВЫБИРАЮТ НАС</h2>
                <div className={s.wrapper} ref={ref}>
                    {[
                        { id: 1, title: 'Все этапы. Один подрядчик', text: 'Осуществляем полный цикл работ: от аудита и проектирования до поставки, внедрения, ввода в эксплуатацию, обучения и поддержки. Клиент получает один источник ответственности.', Line: LineAdvantages1 },
                        { id: 2, title: 'Отраслевая экспертиза и готовые решения', text: 'Применяем знание специфики Вашей отрасли и проверенные отраслевые шаблоны, чтобы сократить сроки реализации, уменьшить риски внедрения и повысить надёжность технологических процессов.', Line: LineAdvantages3 },
                        { id: 3, title: 'Независимость производства через российские решения', text: 'Проектируем АСУ ТП или переводим Ваши системы управления на базе российского оборудования и ПО, гарантируя уровень автоматизации не ниже прежнего.', Line: LineAdvantages5 },
                        { id: 4, title: 'Техническая поддержка и сервисные контракты', text: 'Отвечаем за результат и после сдачи объекта, оперативно реагируем на заявки. Формируем гибкие сервисные контракты и берем на себя мониторинг, профилактику и оперативное решение любых инцидентов.', Line: LineAdvantages1 },
                        { id: 5, title: 'Прозрачность проекта и регулярная отчетность', text: 'Строим доверие через открытость. Прозрачность как основа партнерства: общий доступ к данным по проекту.', Line: LineAdvantages7 },
                        { id: 6, title: 'Человеко-ориентированная автоматизация', text: 'Создаём новую систему автоматизации не вместо людей, а для людей. Её цель — освободить вас от рутины, дать больше контроля над процессом и создать комфортные условия для качественной работы.', Line: LineAdvantages7 }
                    ].map((item, index) => (
                        <motion.div
                            key={item.id}
                            className={s.text}
                            custom={index}
                            initial="hidden"
                            animate={controls}
                            variants={animation}
                            whileHover="hovered"
                            onHoverEnd={() => controls.start('initialPosition')}
                        >
                            <item.Line className={s.line} />
                            <h2>{item.title}</h2>
                            <p>{item.text}</p>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    )
}

export default Advantages
